module.exports = __webpack_public_path__ + "static/media/botBox.639b8fa7.svg";